<!-- 📌 src/components/shared/EmailInput.vue -->
<template>
  <div class="mb-3">
    <label>{{ label }}</label>
    <div class="email-input-container">
      <div v-for="(email, index) in modelValue" :key="index" class="email-tag">
        {{ email }}
        <span class="remove" @click="removeEmail(index)">✕</span>
      </div>
      <input
        type="text"
        v-model="newEmail"
        @keyup.enter="addEmail"
        @blur="addEmail"
        placeholder="宛先を追加"
        class="email-input"
      />
    </div>
    <select v-if="filteredEmails.length > 0" class="form-select" @change="selectEmail">
      <option value="" disabled selected>選択してください</option>
      <option v-for="email in filteredEmails" :key="email" :value="email">
        {{ email }}
      </option>
    </select>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  props: {
    label: String, // "宛先 (TO)" など
    modelValue: Array, // TO / CC / BCC のデータ
    filteredEmails: Array, // 候補メールリスト
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const newEmail = ref("");

    const addEmail = () => {
      if (newEmail.value.trim() !== "" && !props.modelValue.includes(newEmail.value.trim())) {
        emit("update:modelValue", [...props.modelValue, newEmail.value.trim()]);
      }
      newEmail.value = "";
    };

    const removeEmail = (index) => {
      const updatedList = [...props.modelValue];
      updatedList.splice(index, 1);
      emit("update:modelValue", updatedList);
    };

    const selectEmail = (event) => {
      const selectedEmail = event.target.value;
      if (selectedEmail && !props.modelValue.includes(selectedEmail)) {
        emit("update:modelValue", [...props.modelValue, selectedEmail]);
      }
      event.target.value = ""; // Reset select box
    };

    return {
      newEmail,
      addEmail,
      removeEmail,
      selectEmail,
    };
  },
};
</script>

<style scoped>
.email-input-container {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  padding: 5px;
  min-height: 32px;
  align-items: center;
}

.email-tag {
  background-color: #e0e0e0;
  padding: 5px 10px;
  margin: 2px;
  border-radius: 15px;
  display: flex;
  align-items: center;
}

.remove {
  margin-left: 5px;
  cursor: pointer;
}

.email-input {
  border: none;
  outline: none;
  flex: 1;
  padding: 5px;
  font-size: 14px;
}
</style>
